import { render, staticRenderFns } from "./FpuiCategories.vue?vue&type=template&id=7c151213&lang=pug&"
import script from "./FpuiCategories.vue?vue&type=script&lang=js&"
export * from "./FpuiCategories.vue?vue&type=script&lang=js&"
import style0 from "./FpuiCategories.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports